import React from 'react';

const SpecificTreatment = ({ feature, t }) => {
  // Map feature names to locale keys
  const featureMap = {
    "HyperDRY": "hyperdry",
    "HyperDry": "hyperdry",
    "HyperDRY Eco": "hyperdry",
    "HyperDry Eco": "hyperdry",
    "ExpeDRY": "expedry",
    "ExpeDry": "expedry",
    "EXPEDRY": "expedry",
    "UltraWHT": "ultrawht",
    "UltraWht": "ultrawht",
    "ThermaDown O2+": "thermadown"
  };

  const key = featureMap[feature];
  if (!key) {
    console.warn(`[TREATMENT] No locale key found for feature: ${feature}`);
    return <>SpecificTreatment Undefined: {feature}</>;
  }

  // Dynamically render all paragraphs (p1, p2, p3...) found in the locale
  const paragraphs = [];
  let i = 1;
  let translatedParagraph = t(`treatment.${key}.p${i}`);
  while (translatedParagraph !== `treatment.${key}.p${i}`) {
    paragraphs.push(translatedParagraph);
    i++;
    translatedParagraph = t(`treatment.${key}.p${i}`);
  }

  return (
    <>
      <p>
        {t(`treatment.${key}.title`)}<br />
        {t(`treatment.${key}.subtitle`)}
      </p>
      {paragraphs.map((p, idx) => (
        <p key={idx}>{p}</p>
      ))}
      <p>
        <a href={t(`treatment.${key}.cta_url`)} target="_blank" rel="noopener noreferrer">
          {t(`treatment.${key}.cta_text`)}
        </a>
      </p>
    </>
  );
};

const Treatment = (props) => {
  const { apply, t, changeWord } = props;
  const feature = apply && apply[0];

  if (!feature) return null;

  return (
    <div className="content-ac tr hide" data-feature={feature}>
      <input
        className="ac-input top"
        id="ac-8afd"
        name="ac-8afd"
        data-id="2400"
        data-slug="TREATMENT"
        type="checkbox"
        onChange={() => changeWord('TREATMENT')}
      />
      <label className="ac-label" htmlFor="ac-8afd">
        {feature} {t("treatment.label")}
      </label>
      <article className="ac-text ac-8afd">
        <div className="single-post-interior" tabIndex="0">
          <SpecificTreatment
            feature={feature}
            t={t}
          />
          <footer></footer>
        </div>
      </article>
    </div>
  );
};

export default Treatment;
